import React from 'react';
import SEO from '../../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './PaidAdsLegal.css';

const PaidAdsLegal = () => {
    return (
        <div className="industry-service-page">
            <SEO 
                title="Paid Ads Legal Services | Digi Network" 
                description="Learn more about our Paid Ads Legal services to grow your business online with Digi Network." 
                canonical="/industries/legal/services/paidadslegal" 
            />

            {/* Hero Section */}
            <section className="industry-service-hero">
                <div className="industry-service-hero-bg"></div>
                <div className="container">

                        
                    <div className="industry-service-hero-content">
                        <div className="label">PAID ADVERTISING</div>
                        <h1>Paid Advertising for Legal</h1>
                        <p className="industry-service-hero-description">Drive qualified clients with targeted advertising campaigns across Google, Facebook, Instagram, and other platforms. Our legal-focused paid advertising helps you attract the right clients and grow your business efficiently.</p>
                        <div className="industry-service-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                            Get Free Ad Audit
                            <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                            </svg>
                        </Link>
                        </div>
                    </div>
                </div>
            </section>
            {/* Stats Section */}
            <section className="seo-stats">
                <div className="container">
                    <div className="stats-grid">
                        <div className="stat-card">
                            <div className="stat-number">5x</div>
                            <div className="stat-label">Average ROAS</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">40%</div>
                            <div className="stat-label">Lower Cost Per Click</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">200%</div>
                            <div className="stat-label">Conversion Rate Boost</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">24/7</div>
                            <div className="stat-label">Campaign Monitoring</div>
                        </div>
                    </div>
                </div>
            </section>


            {/* Legal Paid Ads Services */}
            <section className="industry-service-details">
                <div className="container">
                    <h2>Legal Paid Ads Services</h2>
                    <p>Paid Ads strategies designed specifically for legal businesses</p>

                    <div className="service-features-grid">
                        <div className="feature-card">
                            
                            <h3>Google Ads Management</h3>
                            <p>Target high-intent searches with Google Ads campaigns optimized for consultation conversion.</p>
                            <ul>
                                <li>Search campaign management</li>
                                <li>Display advertising</li>
                                <li>Shopping ads (if applicable)</li>
                                <li>YouTube video ads</li>
                                <li>Smart bidding optimization</li>
                                <li>Conversion tracking</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Social Media Advertising</h3>
                            <p>Reach your target audience on Facebook, Instagram, and LinkedIn with engaging ad campaigns.</p>
                            <ul>
                                <li>Facebook & Instagram ads</li>
                                <li>LinkedIn advertising</li>
                                <li>TikTok ads (if applicable)</li>
                                <li>Audience targeting</li>
                                <li>Creative development</li>
                                <li>A/B testing</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Targeting & Segmentation</h3>
                            <p>Reach the right clients with precision targeting based on demographics, interests, and behavior.</p>
                            <ul>
                                <li>Demographic targeting</li>
                                <li>Interest-based targeting</li>
                                <li>Behavioral targeting</li>
                                <li>Geographic targeting</li>
                                <li>Lookalike audiences</li>
                                <li>Custom audiences</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Landing Page Optimization</h3>
                            <p>Create high-converting landing pages designed to turn visitors into clients.</p>
                            <ul>
                                <li>Conversion-focused design</li>
                                <li>A/B testing</li>
                                <li>Mobile optimization</li>
                                <li>Fast loading times</li>
                                <li>Clear call-to-actions</li>
                                <li>Form optimization</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Retargeting Campaigns</h3>
                            <p>Re-engage visitors who didn't convert with strategic retargeting campaigns.</p>
                            <ul>
                                <li>Website retargeting</li>
                                <li>Social media retargeting</li>
                                <li>Email list retargeting</li>
                                <li>Dynamic product ads</li>
                                <li>Sequential messaging</li>
                                <li>Cross-platform retargeting</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Campaign Analytics</h3>
                            <p>Track performance, optimize campaigns, and maximize your advertising ROI.</p>
                            <ul>
                                <li>Conversion tracking</li>
                                <li>ROI analysis</li>
                                <li>Cost per acquisition</li>
                                <li>Click-through rates</li>
                                <li>Quality score monitoring</li>
                                <li>Monthly reporting</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* Why Choose Section */}
            <section className="why-seo-matters">
                <div className="container">
                    <div className="section-header">
                        <h2>Why Choose Our Paid Advertising Services</h2>
                        <p>Discover what makes our paid advertising services stand out from the competition</p>
                    </div>
                    <div className="why-seo-points">
                        <div className="why-point">
                            <h4>🚀 Instant Results</h4>
                            <p>Start generating leads immediately with campaigns that drive traffic from day one.</p>
                        </div>
                        <div className="why-point">
                            <h4>🎯 Precision Targeting</h4>
                            <p>Reach your exact audience with advanced targeting options and data-driven strategies.</p>
                        </div>
                        <div className="why-point">
                            <h4>💡 Full Transparency</h4>
                            <p>See exactly where your budget goes with detailed reporting and real-time performance tracking.</p>
                        </div>
                        <div className="why-point">
                            <h4>📊 Continuous Optimization</h4>
                            <p>We constantly test and refine campaigns to maximize ROI and lower acquisition costs.</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* Process Section */}
            <section className="seo-process">
                <div className="container">
                    <div className="section-header">
                        <div className="label">OUR PROCESS</div>
                        <h2>Our Paid Advertising Process</h2>
                        <p>A proven methodology designed specifically for legal businesses</p>
                    </div>

                    <div className="process-grid">
                        <div className="process-step">
                            <div className="process-number">01</div>
                            <h3>Research & Planning</h3>
                            <p>Analyze your audience, competitors, and identify the best advertising channels.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">02</div>
                            <h3>Campaign Setup</h3>
                            <p>Create compelling ad copy, design creative assets, and configure targeting.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">03</div>
                            <h3>Launch & Monitor</h3>
                            <p>Launch campaigns and monitor performance metrics in real-time.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">04</div>
                            <h3>Optimize & Scale</h3>
                            <p>Test, refine, and scale successful campaigns for maximum ROI.</p>
                        </div>
                    </div>
                </div>
            </section>



            {/* Legal Paid Ads Process */}

            {/* CTA Section */}
            <section className="industry-service-cta">
                <div className="container">
                    <h2>Ready to Drive More Clients with Paid Ads?</h2>
                    <p>Get a free advertising audit and discover how we can help you reach more clients and grow your business.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Get Free Ad Audit
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default PaidAdsLegal;
